export default __webpack_public_path__ + "static/media/red-giftcard.b35c2033.svg";